import axios from 'axios';

export const FETCH_DRAFTSINDIVIDUAL_BEGIN = 'FETCH_DRAFTSINDIVIDUAL_BEGIN';
export const FETCH_DRAFTSINDIVIDUAL_SUCCESS = 'FETCH_DRAFTSINDIVIDUAL_SUCCESS';
export const FETCH_DRAFTSINDIVIDUAL_FAILURE = 'FETCH_DRAFTSINDIVIDUAL_FAILURE';


export const fetchDraftsIndividualBegin = () => ({
    type: FETCH_DRAFTSINDIVIDUAL_BEGIN
});

export const fetchDraftsIndividualSuccess = DraftsIndividual => ({
    type: FETCH_DRAFTSINDIVIDUAL_SUCCESS,
    payload: DraftsIndividual
});

export const fetchDraftsIndividualFailure = error => ({
    type: FETCH_DRAFTSINDIVIDUAL_FAILURE,
    payload: { error }
});

export const getDraftsIndividual = (aemurl) => {
   
    return dispatch => {
        dispatch(fetchDraftsIndividualBegin());

        const options = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            withCredentials: true
        };

        return axios.get(aemurl, null, options)
            .then(responseArr => {
                return dispatch(fetchDraftsIndividualSuccess(responseArr.data)); 
            })
            .catch(error => {
                if (error.response) {
                    if (error.response.status === 200) {
                        return dispatch(fetchDraftsIndividualFailure("System error DRI.1a: " + error.request.statusText));
                    }
                    else {
                        if (error.response.data !== "") {
                            return dispatch(fetchDraftsIndividualFailure("System error DRI.1e: " + error.response.data.errors[0]));
                        }
                        return dispatch(fetchDraftsIndividualFailure("System error DRI.1d: " + error.request.statusText));
                    }
                } else if (error.request) {
                    return dispatch(fetchDraftsIndividualFailure("System error DRI.1b: " + error.request.statusText));
                } else {
                    return dispatch(fetchDraftsIndividualFailure("System error DRI.1c: " + error));
                }
            });
       
      
    };
}

